import { IStatusConfigItem } from '../../../../network/models/OrderTypes'
import { ORDER_STATUE_CONFIG } from '../../../../config/index'

export const getStatusValByKey = (
  status?: number,
  orderType: string = 'mobile',
  key?: keyof IStatusConfigItem
) => {
  const statusMatch = ORDER_STATUE_CONFIG.find(
    (item: IStatusConfigItem) => item.status === status
  )

  if (statusMatch && key && key !== 'status') {
    return statusMatch[key][orderType]
  }
  return ''
}
